import { cn } from "../lib/utils";

export default function KPICard({ label, value, accent = "primary", icon: Icon, hint, className, testId }) {
  const accentMap = {
    primary: "text-primary bg-primary/10",
    blue: "text-blue-700 bg-blue-100",
    amber: "text-amber-700 bg-amber-100",
    red: "text-red-700 bg-red-100",
    violet: "text-violet-700 bg-violet-100",
    emerald: "text-emerald-700 bg-emerald-100",
    slate: "text-slate-700 bg-slate-100",
  };
  return (
    <div
      data-testid={testId}
      className={cn(
        "relative p-5 rounded-xl border border-border bg-card shadow-soft hover:shadow-card transition-shadow",
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div className="text-[11px] font-medium uppercase tracking-widest text-muted-foreground">
          {label}
        </div>
        {Icon && (
          <div className={cn("w-8 h-8 rounded-lg grid place-items-center", accentMap[accent])}>
            <Icon className="w-4 h-4" />
          </div>
        )}
      </div>
      <div className="mt-3 font-heading text-3xl font-semibold tracking-tight tabular-nums">
        {value}
      </div>
      {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}
